module.exports = __webpack_public_path__ + "img/dashboards-es.7ac9d2dd.png";